/**
 * The tag vocabulary the task register's filter offers.
 *
 * Beside the toolbar rather than inside it, for the reason the project
 * register's `filterOptions.ts` gives: a component that fetches is a component
 * nobody can read at a glance, and the toolbar is otherwise stateless - what it
 * is showing comes from the address bar, and this list is the one thing that has
 * to come from the server.
 *
 * It does not throw and it reports no error. A filter whose options did not
 * arrive is a menu with nothing to offer, which is also what an untagged CRM
 * looks like; an error banner over a register that loaded perfectly well would
 * be the screen shouting about the wrong thing.
 *
 * Fetched per mount rather than cached for the session: the vocabulary changes
 * whenever somebody edits a task, and the list is small (one narrow column, one
 * fold). A stale menu is worse than a repeated request - it offers a tag that no
 * longer exists, and the empty result reads as a broken filter.
 */
import { useEffect, useState } from "react";
import { getTaskTags } from "../../../lib/projects";

export function useTaskTags(): string[] {
  const [tags, setTags] = useState<string[]>([]);

  useEffect(() => {
    let live = true;
    getTaskTags()
      .then((r) => {
        if (live) setTags(r.rows);
      })
      .catch(() => {});
    return () => {
      live = false;
    };
  }, []);

  return tags;
}
